import { useEffect, useRef } from 'preact/hooks';

export const useRisingClouds = (shouldBeActive: boolean = true) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
 
    useEffect(() => {
        if (!shouldBeActive) {
            console.log('Rising clouds disabled');
            return;
        }
        const canvas = document.createElement('canvas');
        canvasRef.current = canvas;
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'none'; // click-through
        canvas.style.zIndex = '-1'; // above all content
        document.body.appendChild(canvas);

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', resize);
        resize();

        class Cloud {
            x: number;
            y: number;
            size: number;
            speed: number;
            opacity: number;

            constructor() { this.reset(); }

            reset() {
                this.x = Math.random() * canvas.width;
                this.y = canvas.height + Math.random() * 200;
                this.size = 50 + Math.random() * 150;
                this.speed = 0.2 + Math.random() * 0.5;
                this.opacity = 0.3 + Math.random() * 0.3;
            }

            draw() {
                const gradient = ctx.createRadialGradient(
                    this.x, this.y, this.size * 0.3,
                    this.x, this.y, this.size
                );
                gradient.addColorStop(0, `rgba(255,255,255,${this.opacity})`);
                gradient.addColorStop(1, 'rgba(255,255,255,0)');
                ctx.fillStyle = gradient;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
            }

            update() {
                this.y -= this.speed;
                if (this.y + this.size < 0) this.reset();
                this.draw();
            }
        }

        const clouds = Array.from({ length: 30 }, () => new Cloud());
        console.log('Rising clouds initialized with', clouds.length, 'clouds');

        let animationId: number;
        const animate = () => {
            ctx.fillStyle = '#D9D1E5'; // light purple background
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            clouds.forEach(c => c.update());
            animationId = requestAnimationFrame(animate);
        };

        animate();
        console.log('Rising clouds animation started');

        return () => {
            cancelAnimationFrame(animationId);
            window.removeEventListener('resize', resize);
            canvas.remove();
        };
    }, [shouldBeActive]);

    return canvasRef;
};
